export default __webpack_public_path__ + "static/media/fire.df8250e9.webp";